// extracted by mini-css-extract-plugin
export default {"title":"CardSectionTitle_title__3ALLu"};